export const termsAndConditionsLink = 'https://www.tallo.ai/terms-and-conditions';
export const privacyAndPolicyLink = 'https://www.tallo.ai/privacy-policy';
export const transUnionTermsOfUseLink = 'https://files.tallo.ai/public/trans-union-terms-and-conditions.pdf';
export const advertisingForSaleandForRentListingsSimultaneouslyLink =
  'https://help.zillowrentalmanager.com/hc/en-us/articles/213339187-Advertising-For-Sale-and-For-Rent-Listings-Simultaneously';
